module.exports = __webpack_public_path__ + "img/logo.2e7c928a.png";